import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../axiosInterceptor";

const GATEWAY_BASE = process.env.REACT_APP_API_GATEWAY_BASE;
const SUBS_BASE = process.env.REACT_APP_SUBSCRIPTION_BASE || "";

export const getBillingHistory = createAsyncThunk("getBillingHistory", async () => {
  const { data } = await axios.get(
    `${GATEWAY_BASE + SUBS_BASE}/api/transactions/v1?skip=0&limit=1000&tierId=all`
  );
  return data;
});

const getBillingHistorySlice = createSlice({
  name: "getBillingHistory",
  initialState: {
    loading: false,
    billingHistory: null as any,
    error: false,
    success: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getBillingHistory.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getBillingHistory.fulfilled, (state, action) => {
      state.loading = false;
      state.success = true;
      state.billingHistory = action.payload;
    });
    builder.addCase(getBillingHistory.rejected, (state, action) => {
      state.loading = false;
      state.error = true;
    });
  },
});

export default getBillingHistorySlice.reducer;
